export default __webpack_public_path__ + "static/media/Ballroll_00360.48f96f23.png";